import React from 'react'
import { Result } from 'antd'

const NotFound = () => (
	<div
		style={{
			width: '100%',
			height: '100%',
			padding: '16px 32px',
			backgroundColor: '#fff',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center'
		}}
	>
		<Result
			status="404"
			title="404"
			subTitle="Sorry, the page you visited does not exist."
		/>
	</div>
)

export default NotFound
